export const STUDENT_LABS_LOADING = 'STUDENT_LABS_LOADING';
export const STUDENT_LABS_LOADED = 'STUDENT_LABS_LOADED';
export const STUDENT_LABS_ERROR = 'STUDENT_LABS_ERROR';

export const CATEGORIES_LOADING = 'STUDENT_CATEGORIES_LOADING';
export const CATEGORIES_LOADED = 'STUDENT_CATEGORIES_LOADED';
export const CATEGORIES_ERROR = 'STUDENT_CATEGORIES_ERROR';

export const DISPLAY_ITEMS_LOADING = 'STUDENT_DISPLAY_ITEMS_LOADING';
export const DISPLAY_ITEMS_LOADED = 'STUDENT_DISPLAY_ITEMS_LOADED';
export const DISPLAY_ITEMS_ERROR = 'STUDENT_DISPLAY_ITEMS_ERROR';

export const ADD_TO_BUCKET = 'STUDENT_ADD_TO_BUCKET';
export const REMOVE_FROM_BUCKET = 'STUDENT_STUDENT_REMOVE_FROM_BUCKET';
export const INCREASE_ITEM_BUCKET_QUNATITY = 'INCREASE_ITEM_BUCKET_QUNATITY';
export const DECREASE_ITEM_BUCKET_QUNATITY = 'DECREASE_ITEM_BUCKET_QUNATITY';

export const REQUEST_CREATE_LOADING = 'REQUEST_CREATE_LOADING';
export const REQUEST_CREATE_SUCCESS = 'REQUEST_CREATE_SUCCESS';
export const REQUEST_CREATE_ERROR = 'REQUEST_CREATE_ERROR';

export const STUDENT_BUCKET_LECTURERS_LOADING =
  'STUDENT_BUCKET_LECTURERS_LOADING';
export const STUDENT_BUCKET_LECTURERS_LOADED =
  'STUDENT_BUCKET_LECTURERS_LOADED';
export const STUDENT_BUCKET_LECTURERS_ERROR = 'STUDENT_BUCKET_LECTURERS_ERROR';

export const STUDENT_BORROWED_ITEMS_LOADING = 'STUDENT_BORROWED_ITEMS_LOADING';
export const STUDENT_BORROWED_ITEMS_LOADED = 'STUDENT_BORROWED_ITEMS_LOADED';
export const STUDENT_BORROWED_ITEMS_ERROR = 'STUDENT_BORROWED_ITEMS_ERROR';
export const RESET_STUDENT_BORROWED_ITEMS_STATE =
  'RESET_STUDENT_BORROWED_ITEMS_STATE';
